import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Store } from '../models/store';

@Injectable()
export class PaymentGatewayService{
  endpoint = environment.orderApiBackend;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
    })
  };

  constructor(private http: HttpClient){}

  getHPPUrl(store_id: number, orderHash: string, orderName?: string) {
    const params: any = {
      order_hash: orderHash, store_id: store_id
    }
    // Carry the typed name so the backend persists it atomically before the
    // Worldnet redirect (which otherwise drops it). Omitted when not provided.
    if (orderName) { params.order_name = orderName; }
    return this.http.get(`${this.endpoint}/backend/gateway/worldnet/hpp-payload/`, {params: params});
  }

  getHPPUrlGA(store_id: number, orderHash: string, amount: number, orderName?: string) {
    const params: any = {
      order_hash: orderHash, store_id: store_id, amount: amount
    }
    if (orderName) { params.order_name = orderName; }
    return this.http.get(`${this.endpoint}/backend/gateway/worldnet/hpp-payload/ga`, {params: params});
  }

  // ENG-5728: Apple Pay / Google Pay paid on the order summary page, no hosted-page redirect.
  getWalletConfig(storeId: number, orderHash: string) {
    return this.http.get(`${this.endpoint}/backend/gateway/worldnet/wallet-config/`,
      {params: {store_id: storeId, order_hash: orderHash}});
  }

  startApplePaySession(storeId: number, orderHash: string, validationUrl: string) {
    return this.http.post(`${this.endpoint}/backend/gateway/worldnet/apple-pay-session/`, {
      store_id: storeId, order_hash: orderHash, validation_url: validationUrl
    }, this.httpOptions);
  }

  walletPay(storeId: number, orderHash: string, wallet: 'APPLEPAY' | 'GOOGLEPAY', paymentData: any) {
    return this.http.post(`${this.endpoint}/backend/gateway/worldnet/wallet-pay/`, {
      store_id: storeId, order_hash: orderHash, wallet: wallet, payment_data: paymentData
    }, this.httpOptions);
  }

  confirmOrder(params: any) {
    return this.http.get(`${this.endpoint}/backend/gateway/worldnet/receipt`, {params: params})
  }

  updateBillingAddress(orderHash: string, street: string, city: string, zipCode: string) {
    return this.http.post(`${this.endpoint}/backend/gateway/worldnet/update-billing-address/`, {
      order_hash: orderHash,
      street: street,
      city: city,
      zip_code: zipCode
    }, this.httpOptions);
  }

  verifyCard(orderHash: string) {
    return this.http.post(`${this.endpoint}/backend/gateway/worldnet/verify-card/`, {
      order_hash: orderHash
    }, this.httpOptions);
  }
}
